module.exports = __webpack_public_path__ + "4bf104f1d74858b36f7b2c9945d2fd22.jpg";